const normalizeBase = (value: string): string => value.replace(/\/+$/, '');

let cachedBase: string | null = null;

export function getApiBase(): string {
  if (cachedBase !== null) {
    return cachedBase;
  }

  const envBase = import.meta.env?.VITE_API_BASE;
  if (typeof envBase === 'string' && envBase.trim()) {
    cachedBase = normalizeBase(envBase.trim());
    return cachedBase;
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    cachedBase = normalizeBase(window.location.origin);
    return cachedBase;
  }

  cachedBase = '';
  return cachedBase;
}

export function buildApiUrl(path: string): string {
  const safePath = path.startsWith('/') ? path : `/${path}`;
  return `${getApiBase()}${safePath}`;
}
